import { Token } from "@stripe/stripe-js";

import { xhttp } from "../Fetchv2.js";
import { PGSchema } from "../schemas/pg.schema.js";

export class StripeAPI {
	/**
	 * Este crea un checkout session en stripe
	 * /pages/:pgid/pay_session
	 */
	async createStripeCheckoutSession(pgid: string, data: { price_id: PGSchema.product_prices["id"]; billing_email: string; product_id: number }, token: string) {
		return xhttp<{ session_url: string }>(`/pages/${pgid}/pay_session`, "POST", data, {
			headers: { "app-token": token }
		});
	}

	/**
	 * Este actualiza el plan de stripe en segundo plano sin usar la checkout session
	 *
	 * /stripe/:pgid/subscription
	 */
	async upgradeSubscription(pgid: string, data: { product_id: PGSchema.products["id"]; price_id: PGSchema.product_prices["id"]; subscription: PGSchema.subscriptions["id"] }, token: string) {
		return xhttp(`/stripe/${pgid}/subscription`, "PATCH", data, {
			headers: { "app-token": token }
		});
	}

	/**
	 * Este cancela o reactiva la suscripción de stripe en segundo plano (la verdadera cancelacion pasa por el webhook al vencer el mes)
	 *
	 * /stripe/:pgid/subscription
	 */
	async cancelORRenewSubscription(pgid: PGSchema.pages["id"], subscription: PGSchema.subscriptions["id"], cancel_at_period_end: boolean, token: string) {
		return xhttp(
			`/stripe/${pgid}/subscription`,
			"PUT",
			{
				subscription_id: subscription,
				cancel_at_period_end
			},
			{
				headers: { "app-token": token }
			}
		);
	}

	/**
	 * Este crea una session para el portal del cliente para manejar su suscripción en stripe
	 *
	 * /stripe/:pgid/customer_session
	 */
	async createCustomerPortalSession(pgid: string, token: string) {
		return xhttp<{ url: string }>(
			`/stripe/${pgid}/customer_session`,
			"POST",
			{},
			{
				headers: { "app-token": token }
			}
		);
	}

	async attachPaymentMethod(pgid: string, data: { payment_method: string }, token: string) {
		return xhttp<{ pm: Token; customer: string }>(`/stripe/${pgid}/payment_method`, "POST", data, {
			headers: { "app-token": token }
		});
	}

	async detachPaymentMethod(pgid: string, data: { payment_method: string }, token: string) {
		return xhttp(`/stripe/${pgid}/payment_method`, "DELETE", data, {
			headers: { "app-token": token }
		});
	}

	async setAsDefaultPaymentMethod(pgid: string, data: { payment_method: string }, token: string) {
		return xhttp(`/stripe/${pgid}/payment_method`, "PUT", data, {
			headers: { "app-token": token }
		});
	}
}
